export interface Page<T> {
  content: Array<T>;
  empty: boolean;
  first: boolean;
  last: boolean;
  number: number;
  numberOfElements: number;
  pageable: Pageable<Sort>;
  size: number;
  sort: Sort;
  totalElements: number;
  totalPages: number;
}

interface Sort {
  empty: boolean;
  sorted: boolean;
  unsorted: boolean;
}

interface Pageable<T> {
  offset: number;
  pageNumber: number;
  pageSize: number;
  paged: boolean;
  sort: T;
  unpaged: boolean;
}
